import { createAction } from '@reduxjs/toolkit';

export const shopListContainerActions = {
  navigateTo: createAction<{ navigateTo: string }>('ShopListContainer/NavigateTo'),
};
